import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import Map from './pages/Map';
import WeddingRSVPForm from './pages/WeddingRSVPForm';
import Faq from './pages/Faq';
import { datadogRum } from '@datadog/browser-rum';

function App() {
  const [datadogConfig, setDatadogConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/api/config');
        if (!response.ok) throw new Error('Failed to fetch config');

        const config = await response.json();
        setDatadogConfig(config);
      } catch (error) {
        console.error("Error fetching config:", error);
      }
    };

    fetchConfig();
  }, []);

  useEffect(() => {
    if (datadogConfig) {
      // Initialize Datadog RUM
      datadogRum.init({
        applicationId: datadogConfig.DD_APPLICATION_ID,
        clientToken: datadogConfig.DD_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: 'leslieloic-wedding-website',
        env: datadogConfig.DD_ENV,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: 'mask-user-input',
      });

      // Start tracking user interactions and performance
      datadogRum.startSessionReplayRecording();
    }
  }, [datadogConfig]); // Run once when the component mounts

  return (
    <Router>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/map" element={<Map />} />
          <Route path="/wedding-rsvp" element={<WeddingRSVPForm />} />
          <Route path="/faq" element={<Faq/>} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
